// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"33":"scheduling","93":"maintenance","250":"organizations","328":"admin","343":"risk","491":"invoicing","588":"dark","601":"dispatching","687":"warehouse","717":"pricing","881":"safety","966":"audits"}[chunkId] + ".css";
};